/* eslint-disable camelcase */
import { CollectionEntity } from "@busy-human/gearbox";
import { Events } from "../Event/index.js";
import { ScheduleRequest } from "../ScheduleRequests/index.js";
export var Invoices;
(function (Invoices) {
    // The amount Busy Human charges per transaction
    const BH_FEE_RATE = 0.01;
    // The base fee in dollars that Busy Human will charge
    const BH_BASE_FEE = 0.50;
    // Stripe charges 2.9% per transaction for card transactions https://stripe.com/pricing
    const STRIPE_FEE_RATE = 0.029;
    // Stripe charges 5.99% per transaction for affirm transactions https://stripe.com/pricing
    const STRIPE_AFFIRM_FEE_RATE = 0.0599;
    // Stripe charges 0.30 per transaction for card transactions https://stripe.com/pricing
    const STRIPE_BASE_FEE = 0.30;
    /**
     * Canine wants their customer to pay all the fees so they net their given price
     * So we have to take the target net and add the fees to it to get amount the customer is charged
     */
    function calculateGrossCharge(targetNet, stripeFeeRate = STRIPE_FEE_RATE) {
        return (targetNet + BH_BASE_FEE + STRIPE_BASE_FEE) / (1 - BH_FEE_RATE - stripeFeeRate);
    }
    Invoices.calculateGrossCharge = calculateGrossCharge;
    function estimateStripeFee(targetNet, stripeFeeRate = STRIPE_FEE_RATE) {
        return (targetNet * stripeFeeRate) + STRIPE_BASE_FEE;
    }
    Invoices.estimateStripeFee = estimateStripeFee;
    /** Prices for trainings */
    Invoices.EventPricing = {
        [Events.TrainingType.Test]: { 1: 1.0, 2: 1.0, 3: 1.0, 4: 1.0, 5: 1.0, 6: 1.0, 7: 1.0, 8: 1.0 },
        [Events.TrainingType.Fundamentals]: { 3: 3655.0 },
        [Events.TrainingType.Executive]: { 12: 13361.0 },
        [Events.TrainingType.Advanced]: { 4: 3997.0, 6: 5993.0, 8: 7995.0 }
    };
    Invoices.BOARDING_PRICE_PER_NIGHT = 55.0;
    function calculatePriceOfBoarding(req) {
        const length = ScheduleRequest.eventLengthNights(req);
        const price = length * Invoices.BOARDING_PRICE_PER_NIGHT;
        return price;
    }
    Invoices.calculatePriceOfBoarding = calculatePriceOfBoarding;
    /**
     * Returns the gross amount to charge and the fee to charge in cents
     * @param invoiceData
     * @returns
     */
    function calculateFeesAndCents(invoiceData, options) {
        // The base_amount is whatever is left on the invoice
        const base_amount = options?.price ?? (invoiceData.totalAmount - invoiceData.paidAmount);
        const stripeFeeRate = options?.paymentMethod === 'affirm' ? STRIPE_AFFIRM_FEE_RATE : STRIPE_FEE_RATE;
        const gross = calculateGrossCharge(base_amount, stripeFeeRate);
        const bh_feeRate = BH_FEE_RATE;
        // Canine wants the fee to be paid by its customers, so we add the fee to the gross
        const bh_fee = (base_amount * bh_feeRate) + BH_BASE_FEE;
        // Stripe prices are in cents, so 1 dollar = 100 cents
        const base_cents = Math.ceil(base_amount * 100);
        const gross_cents = Math.ceil(gross * 100);
        const bh_fee_cents = Math.ceil(bh_fee * 100);
        if (gross_cents <= 0) {
            throw new Error('Gross amount must be greater than zero');
        }
        if (bh_fee_cents >= gross_cents) {
            throw new Error('Fee amount must be less than gross amount');
        }
        if (!bh_fee_cents || Math.floor(bh_fee_cents) !== bh_fee_cents || bh_fee_cents <= 0) {
            console.log("Fee: ", bh_fee);
            throw new Error("fee must be a positive integer");
        }
        const estStripeFees = estimateStripeFee(base_amount, stripeFeeRate);
        const estStripeFees_cents = Math.ceil(estStripeFees * 100);
        return {
            base: base_cents,
            gross: gross_cents,
            fees: {
                bh: bh_fee_cents,
                stripe: estStripeFees_cents,
                gross: bh_fee_cents + estStripeFees_cents
            }
        };
    }
    Invoices.calculateFeesAndCents = calculateFeesAndCents;
    function Defaults() {
        return {
            userId: '',
            invoiceId: '',
            qbInvoiceNumber: "",
            totalAmount: 0,
            paidAmount: 0,
            discountAmount: 0,
            description: '',
            finalPaymentRequired: false,
            initialPaymentPaid: false,
            supportPartialPayments: true
        };
    }
    Invoices.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Defaults;
    }
    Invoices.CollectionClass = CollectionClass;
    Invoices.Collection = new CollectionClass({ path: "/Invoices" });
})(Invoices || (Invoices = {}));
//# sourceMappingURL=index.js.map